import React from 'react';
import Header from './components/Header'; // ¡Nuevo!
import EventServices from './components/EventServices';
import ImageCarousel from './components/ImageCarousel'; // El nuevo carrusel
import ContactForm from './components/ContactForm';
import WhatsAppContact from './components/WhatsAppContact';
import Footer from './components/Footer';


function App() {
  return (
    <div className="App flex flex-col min-h-screen">
      <Header />
      {/* Añadimos padding superior para que el sticky header no tape el contenido */}
      <main className="flex-grow"> 
       <section id="servicios">
        <EventServices />
      </section>
       <section id="galeria">
        <ImageCarousel />
      </section>
        <section id="contacto">
        <ContactForm />
      </section>
        <WhatsAppContact />
        <Footer/>
      </main>
    </div>
  );
}

export default App;
